/** @jsxImportSource @emotion/react */
import React from "react";
import {useHistory} from "react-router-dom";
import {Icon, Menu, MenuDivider, MenuItem} from "@blueprintjs/core";
import {useTranslation} from "react-i18next";

// Libs
import {primaryColor} from "../common/libs/theme-lib";

// Hooks
import {useAuth} from "../auth/auth";

// Components
import Popover from "../common/components/popover";
import ChatWidget from "../common/components/chat-widget";

const HeaderActions = (props) => {
    const auth = useAuth();
    const history = useHistory();
    const {isAdminHeader, setIsAdminHeader} = props;
    const toAdminHome = "/admin-home";
    const toHome = "/home";

    //i18n
    const {t} = useTranslation("common");

    return (
        <div style={{
            margin: "0 36px",
            display: "flex"
        }}>
            <ChatWidget />
            {auth.userType === "admin" && (
                <div
                    css={{
                        cursor: "pointer",
                        color: isAdminHeader ? "black" : primaryColor,
                        backgroundColor: "white",
                        borderRadius: "50%",
                        height: 36,
                        width: 36,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 36,
                        transition: "all 0.4s",
                        "&:hover": {
                            color: "white",
                            backgroundColor: isAdminHeader ? primaryColor : "black"
                        }
                    }}
                    onClick={() => {
                        setIsAdminHeader(!isAdminHeader)
                        isAdminHeader ? !!toHome && history.push(toHome) : !!toAdminHome && history.push(toAdminHome);
                    }}
                >
                    <Icon icon="swap-horizontal" iconSize={24}/>
                </div>
            )}
                <Popover
                    content={(
                        <Menu>
                            <MenuItem
                                text={t("headerActions.profile")}
                                onClick={() => history.push("/profile")}
                            />
                            <MenuDivider/>
                            <MenuItem
                                text={t("headerActions.leave")}
                                onClick={auth.logout}
                                icon={"power"}
                            />
                        </Menu>
                    )}
                    position="left"
                >
                    <div
                        css={{
                            cursor: "pointer",
                            color: "white",
                            height: 36,
                            width: 36,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            transition: "all 0.4s",
                            "&:hover": {
                                color: "white",
                                backgroundColor: isAdminHeader ? primaryColor : "black"
                            }
                        }}
                    >
                        <Icon icon="user" iconSize={36}/>
                    </div>
                </Popover>
        </div>
    );
};

export default HeaderActions;